import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader.tsx";
import { lazy, Suspense } from "react";

const SleepHistoryPage = lazy(() => import("./SleepHistoryPage.tsx"));

function SleepHistoryPageLazy() {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <SleepHistoryPage />
    </Suspense>
  );
}

export default SleepHistoryPageLazy;
